// extracted by mini-css-extract-plugin
module.exports = {"unauthorized__wrapper":"ErrorsPage_unauthorized__wrapper__6pjLD","unauthorized__code":"ErrorsPage_unauthorized__code__XyCOA"};